import { TimesheetDto, UserCoreDto } from 'src/api/FiretrolApiClient';

export interface IRosterMember {
  userId?: number;
  user?: UserCoreDto;
}

/** @registry Timesheet roster: the job team plus every user who owns one of the given timesheets but is no longer on the team (for example, an archived user). */
export const withTimesheetUsers = (
  team: IRosterMember[],
  timesheets: TimesheetDto[],
): IRosterMember[] => {
  const onRoster = new Set(team.map((member) => member.userId));
  const missing: IRosterMember[] = [];
  for (const { userId, user } of timesheets) {
    if (userId == null || onRoster.has(userId)) continue;
    onRoster.add(userId);
    missing.push({ userId, user });
  }
  return missing.length > 0 ? [...team, ...missing] : team;
};
